import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { getErrorMessage } from '../../util/responseUtil';
import { ROUTER_CONSTANT } from '../../constants/routerConstant';
import API_AUTHENTICATION from '../../api/apiAuthentication';
import LoginBackground from '../../assets/images/login-background.svg';
import OutsideLogo from '../../components/Common/OutsideLogo';
import Alert from '../../components/Alert/Alert';

class VerifyUser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userId: '',
            email: '',
            emailCode: '',
            showSuccessAlert: false,
            showErrorAlert: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    componentDidMount() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const userId = urlParams.get('user_id');
        const email = urlParams.get('email');
        const emailCode = urlParams.get('activation_code');

        if (userId !== null && email !== null && emailCode !== null) {
            this.setState({ userId, email, emailCode })
        }
    }

    removeAttribute = e => {
        e.target.removeAttribute('readonly')
    }

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value });
    }

    handleSubmit = e => {
        e.preventDefault();

        const data = {
            user_id: parseInt(this.state.userId),
            email: this.state.email,
            email_code: this.state.emailCode,
            otp_code: '',
            phone: ''
        }

        API_AUTHENTICATION.postVerifyUser(data, this.props.token)
            .then(res => {
                this.setState({ showSuccessAlert: true })
                setTimeout(() => this.setState({ showSuccessAlert: false }), 1500)
                setTimeout(() => this.props.history.push(ROUTER_CONSTANT.LOGIN), 1500)
            }).catch(err => {
                this.setState({ errorMessage: getErrorMessage(err) })
                this.setState({ showErrorAlertResponse: true })
            })
    }

    render() {
        return (
            <div className="w-screen h-screen bg-white relative">
                <OutsideLogo />
                <img alt="Login Background" src={LoginBackground} className="w-full h-full object-contain" />
                <form onSubmit={this.handleSubmit} className="absolute top-32 right-56 w-96 text-gray-600">
                    <p className="text-3xl font-bold">Verifikasi Pengguna Baru</p>
                    <div className="quote font-medium mt-5 mb-20">
                        <p>Masukkan kode yang telah kami kirim ke email Anda.</p>
                    </div>
                    <input
                        type="number"
                        id="tsluserid"
                        name="userId"
                        placeholder="User ID"
                        autoComplete="off"
                        onFocus={this.removeAttribute}
                        onChange={this.handleChange}
                        value={this.state.userId}
                        disabled={this.state.disabled}
                        className="bg-input-outside w-full h-16 text-center outline-none rounded my-2 px-14"
                    />
                    <input
                        type="email"
                        id="tslemail"
                        name="email"
                        placeholder="Email"
                        onChange={this.handleChange}
                        value={this.state.email}
                        disabled={this.state.disabled}
                        className="bg-input-outside w-full h-16 text-center outline-none rounded my-2 px-14"
                    />
                    <input
                        type="text"
                        id="tslemailcode"
                        name="emailCode"
                        placeholder="Kode Verifikasi"
                        onChange={this.handleChange}
                        value={this.state.emailCode}
                        disabled={this.state.disabled}
                        className="bg-input-outside w-full h-16 text-center outline-none rounded my-2 px-14"
                    />
                    <button type="submit" id="btnsave" className="bg-darkblue w-full h-16 text-center text-white outline-none rounded mt-10">Simpan</button>
                </form>
                <Alert show={this.state.showSuccessAlert} icon="success" title="Berhasil Verifikasi Pengguna!" />
                <Alert show={this.state.showErrorAlertResponse} icon="warning" title={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token
    };
};

export default withRouter(connect(mapStateToProps, null)(VerifyUser));